import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkCardAloha, UitkCardAlohaLink, UitkCardAlohaContentSection } from "uitk-react-cards";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { UitkBadge, UitkBadgeTheme, UitkBadgeSize } from "uitk-react-badge";
import { UitkImage } from "uitk-react-experimental-images";
import { UitkLayoutPosition } from "uitk-react-layout-position";

import HotelRating from "../shared/HotelRating";
import CardTitle from "../shared/CardTitle";
import AddressAndNeighborhood from "../shared/AddressAndNeighborhood";
import PricesAndDate from "../shared/PricesAndDate";
import DescriptionAndGuestReviewSectionWrapper from "../shared/DescriptionAndGuestReviewSectionWrapper";
import LoBDetails from "../shared/LobDetails";
import LoBBadge from "../shared/LobBadge";
import { ReviewCountAndRating } from "components/flexComponents/Hotels/components/ReviewCountAndRating";

import { TrackedLink } from "components/utility/analytics/TrackedLink";

import { PackageCardProps } from "components/flexComponents/Packages/typings";

export const PackageCardImageLeft = ({ packageItem, index, language }: PackageCardProps) => {
  const packageType = "fh";
  const { formatText } = useLocalization();

  return (
    <UitkCardAloha className="all-t-margin-three" padded={true}>
      <UitkLayoutGrid columns={2}>
        <UitkLayoutGridItem colSpan={1} className="all-r-margin-two">
          <div>
            <UitkFigure
              ratio={UitkFigureAspectRatioType.R16_9}
              className="all-image-fit-cover uitk-card-aloha-roundcorner-all"
            >
              <UitkImage src={packageItem.hotelImageUrl} alt={packageItem.hotelName} placeholderImage={true} />
              <UitkLayoutPosition type="absolute" position={{ top: "two", left: "two" }}>
                <UitkBadge
                  theme={UitkBadgeTheme.FAMILY_FRIENDLY}
                  size={UitkBadgeSize.SMALL}
                  className="all-y-padding-one all-x-padding-one"
                >
                  <LoBBadge packageType={packageType} />
                </UitkBadge>
              </UitkLayoutPosition>
            </UitkFigure>
          </div>
        </UitkLayoutGridItem>
        <UitkLayoutGridItem colSpan={1}>
          <UitkCardAlohaContentSection padded={false} className="all-x-padding-three">
            <UitkLayoutFlex justifyContent="space-between" className="truncate">
              <UitkLayoutFlexItem className="truncate">
                <div>
                  <HotelRating rating={packageItem.hotelStarRating} isText={true} />
                  <CardTitle cardTitle={packageItem.hotelName} />
                  <AddressAndNeighborhood packageItem={packageItem} />
                  {packageItem.showHotelGuestRating && (
                    <ReviewCountAndRating
                      hotelOverallReviewRating={Number(packageItem.hotelReviewScore)}
                      reviewCount={Number(packageItem.hotelReviewTotal)}
                      language={language}
                    />
                  )}
                  <LoBDetails packageItem={packageItem} />
                </div>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem>
                <div>
                  <PricesAndDate packageItem={packageItem} renderSavingBadge={true} renderDates={false} />
                </div>
              </UitkLayoutFlexItem>
            </UitkLayoutFlex>
            <DescriptionAndGuestReviewSectionWrapper packageItem={packageItem} language={language} marginOnTop={true} />
            <UitkCardAlohaLink>
              <TrackedLink
                className="uitk-card-link"
                rfrr={`card-${index}`}
                href={packageItem.shopUrl}
                aria-label={formatText("package.card.ariaLabel.fh")}
                moduleName="packages"
              />
            </UitkCardAlohaLink>
          </UitkCardAlohaContentSection>
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
    </UitkCardAloha>
  );
};
